module.exports = __webpack_public_path__ + "5e8d1a66dc6fbb8b05fea51515536cd9.svg";